export default "__VITE_ASSET__Z0e0iseC__"